import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PROJECT_ACTIVITY_FEATURE_KEY,
  ProjectActivityState,
  ProjectActivityPartialState,
  projectActivityAdapter,
} from './project-activity.reducer';
import { ProjectActivityDto } from '@cradua/data';

// Lookup the 'ProjectActivity' feature state managed by NgRx
export const getProjectActivityState = createFeatureSelector<
  ProjectActivityPartialState,
  ProjectActivityState
>(PROJECT_ACTIVITY_FEATURE_KEY);

const { selectAll, selectEntities } = projectActivityAdapter.getSelectors();

export const getProjectActivityLoaded = createSelector(
  getProjectActivityState,
  (state: ProjectActivityState) => state.loaded
);

export const getProjectActivityError = createSelector(
  getProjectActivityState,
  (state: ProjectActivityState) => state.error
);

export const loadingProjectActivity = createSelector(
  getProjectActivityState,
  (state: ProjectActivityState) => state.loaded
);

export const getAllProjectActivity = createSelector(
  getProjectActivityState,
  (state: ProjectActivityState) => selectAll(state)
);

export const getProjectActivityEntities = createSelector(
  getProjectActivityState,
  (state: ProjectActivityState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getProjectActivityState,
  (state: ProjectActivityState) => state.selectedProjectActivityId
);

export const getSelected = createSelector(
  getProjectActivityEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getSearchStudentRecord = createSelector(
  getAllProjectActivity,
  getSelectedId,
  (users: ProjectActivityDto[], selectedId) =>
    !selectedId
      ? null
      : users.filter(
          (user) =>
            user.id.toLowerCase().includes(String(selectedId).toLowerCase()) ||
            user.ProjectActivityDescription.toLowerCase().includes(
              String(selectedId).toLowerCase()
            ) ||
            user.ProjectActivityName.toLowerCase().includes(
              String(selectedId).toLowerCase()
            )
        )
);
